import Avatar from '@material-ui/core/Avatar';
import PersonIcon from '@material-ui/icons/Person';
import BlockIcon from '@material-ui/icons/Block';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from '../style/gstheme';
import UserAvatar from './UserAvatar';

const statusList = [
  "https://grafsync.graphifi.com/schema/gs/accepted",
  "https://grafsync.graphifi.com/schema/gs/pending",
  "https://grafsync.graphifi.com/schema/gs/rejected"
];

const statusIcon = [
  CheckIcon,
  AccessTimeIcon,
  ClearIcon
];

const status = [
  "Accepted",
  "Pending",
  "Rejected"
];

class UserCard extends React.Component {

  selectUser = () => this.props.onSelectUser(this.props.user.id);

  render() {

    const { classes, user, invitation, withDrawn, isSelected } = this.props;
    const statusIndex = statusList.indexOf(invitation.status[0]);
    const statusText = withDrawn ? "Withdrawn" : status[statusIndex];
    let Icon = BlockIcon;
    if (!withDrawn) {
      if (statusIndex >= 0) Icon = statusIcon[statusIndex];
    }
    const fn = user.familyName || "";
    const gn = user.givenName || user.username;
    const title = gn + " " + fn;

    return (
      <Card data-test={"user-card-" + user.username} className={isSelected ? classes.gsSelectedCard : classes.gsCard} onClick={this.selectUser}>
        <CardHeader
          data-test="user"
          classes={{
            root: classes.gsCardInner
          }}
          titleTypographyProps={{
            className: classes.gsCardHeader
          }}
          avatar={user.givenName && user.familyName ?
            <UserAvatar size="small" givenName={user.givenName} familyName={user.familyName} />
            :
            <Avatar className={classes.smallPrimaryAvatar}>
              <PersonIcon />
            </Avatar>
          }
          title={
            <div>
              <div style={{ display: 'flex' }}>
                <div variant="body2" style={{ flex: 1 }}>{title}</div>
                <div data-test="user-status" className="gsCardStatus" style={{ transform: 'translateY(2px)' }}>
                  {statusText}
                </div>
                <div data-test="user-status-icon" className="gsCardStatus" style={{ flex: '0 0', verticalAlign: 'middle' }}>{<Icon />}</div>
              </div>
            </div>}
        />
      </Card>
    );
  }
}

UserCard.defaultProps = {
  isSelected: false
};

UserCard.propTypes = {
  classes: PropTypes.object,
  user: PropTypes.object.isRequired,
  isSelected: PropTypes.bool,
  invitation: PropTypes.object.isRequired,
  withDrawn: PropTypes.bool.isRequired,
  onSelectUser: PropTypes.func.isRequired
};

export default withStyles(styles)(UserCard);